var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('p',{staticStyle:{"text-align":"center","font-size":"14px"}},[_c('b',[_vm._v("Desenvolvido por Diego Mauricio da Cruz, Copyright 2021 - Todos os direitos reservados.")])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }